const doc = [({"ja":({"adminConstantRoomPlanDisplayType":({"default":"デフォルト", "noImage":"プラン画像なし", "onlyOne":"1つのみ表示", "onlyPlan":"プランのみ表示"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;